/**
 * Hạng thành viên bán lẻ (/retail/member-tiers): ẨN ở mọi môi trường — owner
 * 10/10/2026 "chưa có nghiệp vụ", ưu đãi chưa áp dụng ở đâu (ERP-07). Giữ code
 * + dữ liệu + API; chỉ ẩn menu, trang và nhóm quyền. Bật lại = đổi thành true
 * (xem docs/decisions/scope-decisions.md).
 */
// Boolean(): kiểu boolean (không phải literal false) để nhánh bật vẫn được kiểm kiểu.
export const RETAIL_MEMBER_TIERS_ENABLED = Boolean(false)
